import Model from "./Model";

export default class extends Model {
    constructor(urls) {
        super(urls);
    }

    async update(params) {
        if(this.urls.update === undefined)
        {
            console.log('error: url_update_undefined');
            return false;
        }
        return await axios.post(this.urls.update, params).then(
          response => {
              return response.data;
          })
    }
}
